<script setup>
const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: 'Embedded content',
  },
  width: {
    type: [String, Number],
    default: '100%',
  },
  height: {
    type: [String, Number],
    default: '100%',
  },
  allow: {
    type: String,
    default:
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
  },
  fullscreen: {
    type: Boolean,
    default: true,
  },
  lazy: {
    type: Boolean,
    default: true,
  },
  ratio: {
    type: String,
    default: '16:9', // або '4:3', '21:9'
  },
});

/** Розрахунок aspect ratio (через padding-top hack) */
const aspectPadding = computed(() => {
  if (!props.ratio) return '56.25%';
  const [w, h] = props.ratio.split(':').map(Number);
  return `${(h / w) * 100}%`;
});
</script>

<template>
  <div class="ui-iframe" :style="{ paddingTop: aspectPadding }">
    <iframe
      :src="url"
      :title="title"
      :width="width"
      :height="height"
      :allow="allow"
      :allowfullscreen="fullscreen"
      :loading="lazy ? 'lazy' : 'eager'"
      frameborder="0"
    ></iframe>
  </div>
</template>

<style scoped lang="scss">
.ui-iframe {
  position: relative;
  width: 100%;
  overflow: hidden;

  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
